import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, loginWithMicrosoft, isMicrosoftSsoEnabled } = useAuth();
  const navigate = useNavigate();

  const getFriendlyLoginError = (err: any): string => {
    if (axios.isAxiosError(err)) {
      const statusCode = err.response?.status;
      const backendDetail =
        typeof err.response?.data?.detail === 'string' ? err.response.data.detail : null;

      if (statusCode === 401) {
        return 'E-mail ou senha inválidos. Confira seus dados e tente novamente.';
      }

      if (statusCode && statusCode >= 500) {
        return 'Estamos com instabilidade no servidor no momento. Tente novamente em alguns minutos.';
      }

      if (backendDetail) {
        return backendDetail;
      }
    }

    if (
      err?.message &&
      !String(err.message).includes('Request failed with status code')
    ) {
      return err.message;
    }

    return 'Não foi possível concluir o login agora. Tente novamente.';
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, password);
      // Se precisa trocar senha, redirecionar para o perfil
      if (result.must_change_password) {
        navigate('/profile', { state: { mustChangePassword: true } });
      } else {
        navigate('/dashboard');
      }
    } catch (err: any) {
      console.error('Login error:', err);
      setError(getFriendlyLoginError(err));
    } finally {
      setLoading(false);
    }
  };

  const handleMicrosoftLogin = async () => {
    setError('');
    try {
      await loginWithMicrosoft();
    } catch (err: any) {
      setError(err?.message || 'Nao foi possivel iniciar o login com Microsoft.');
    }
  };

  return (
    <Container className="login-container">
      <Card className="login-card">
        <Card.Body>
          <div className="text-center mb-4">
            <h1 className="mb-2 text-primary">
              <strong>SUPORTNECT</strong>
            </h1>
            <p className="text-muted">Sistema de ITSM</p>
          </div>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                type="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={loading}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>

            {isMicrosoftSsoEnabled && (
              <>
                <div className="text-center text-muted my-3">ou</div>
                <Button
                  variant="outline-primary"
                  type="button"
                  className="w-100"
                  onClick={handleMicrosoftLogin}
                >
                  Entrar com Microsoft
                </Button>
              </>
            )}
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;


